import * as React from "react";
const SvgOutdoorLounge = ({ title, titleId, ...props }) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M12.75 2.25a.75.75 0 1 0-1.5 0v.015C8.02 2.577 5.353 4.86 4.666 7.29c-.151.537.01 1.047.332 1.4.312.344.768.54 1.246.54h5.003V17H9.5v-1.25c0-.698-.409-1.3-1-1.582v-.918a1.75 1.75 0 0 0-1.75-1.75h-2A1.75 1.75 0 0 0 3 13.25v.918c-.591.281-1 .884-1 1.582v2c0 .414.336.75.75.75h18.5a.75.75 0 0 0 .75-.75v-2c0-.698-.409-1.3-1-1.582v-.918a1.75 1.75 0 0 0-1.75-1.75h-2a1.75 1.75 0 0 0-1.75 1.75v.918c-.591.281-1 .884-1 1.582V17h-1.753V9.23h4.997c.478 0 .935-.196 1.247-.54.323-.353.486-.863.335-1.4-.682-2.431-3.344-4.713-6.576-5.025V2.25ZM8 17H3.5v-1.25a.25.25 0 0 1 .25-.25h4a.25.25 0 0 1 .25.25V17Zm-3.5-3v-.75a.25.25 0 0 1 .25-.25h2a.25.25 0 0 1 .25.25V14H4.5ZM17 14v-.75a.25.25 0 0 1 .25-.25h2a.25.25 0 0 1 .25.25V14H17Zm3.5 3H16v-1.25a.25.25 0 0 1 .25-.25h4a.25.25 0 0 1 .25.25V17ZM6.246 7.73a.2.2 0 0 1-.133-.045C6.66 5.769 9.06 3.73 11.999 3.73c2.94 0 5.335 2.04 5.88 3.957a.2.2 0 0 1-.133.044h-11.5ZM6.094 21.41c-1.011-.547-1.976-.547-2.987 0a.75.75 0 0 1-.713-1.32c1.455-.787 2.957-.787 4.413 0 1.01.547 1.976.547 2.987 0 1.455-.787 2.957-.787 4.413 0 1.01.547 1.976.547 2.986 0 1.456-.787 2.958-.787 4.414 0a.75.75 0 1 1-.713 1.32c-1.011-.547-1.976-.547-2.987 0-1.456.787-2.958.787-4.414 0-1.01-.547-1.975-.547-2.986 0-1.456.787-2.958.787-4.413 0Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgOutdoorLounge;
